export default __webpack_public_path__ + "static/media/ordinaryCoverage.a474292e.png";